<template>
  <div>
    <!-- <label class="font-weight-bold">{{ label }}</label> -->
    <div class="d-flex align-items-center">
      <b-input-group size="md" :prepend="label">
      <b-form-input
        class="form-control"
        v-model="password"
        :type="inputType"
        :placeholder="`${placeholder}`"
        @change="$emit('update:value', password)"
        @input="$emit('update:errorMessage', null)"
        :disabled="disabled"
        :state="state"
      />
      </b-input-group>
      <i
        :class="{
          fas: true,
          'fa-eye': !isShowingPassword,
          'fa-eye-slash': isShowingPassword,
          'c-pointer': true,
          'ml-2': true,
        }"
        :title="description"
        @click="togglePassword()"
      ></i>
    </div>
    <ErrorMessage :errorMessage="errorMessage" />
  </div>
</template>

<script>
import ErrorMessage from '../ErrorMessage.vue';

export default {
  components: {
    ErrorMessage,
  },
  props: {
    label: {
      type: String,
      default: 'Senha',
    },
    placeholder: {
      type: String,
      default: 'Crie uma senha de no mínimo 6 dígitos',
    },
    value: {
      type: String,
    },
    errorMessage: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    state: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      isShowingPassword: false,
      inputType: 'password',
      password: '',
      description: 'Mostrar Senha',
    };
  },
  methods: {
    togglePassword() {
      this.isShowingPassword = !this.isShowingPassword;
      this.inputType = this.inputType === 'text' ? 'password' : 'text';
      this.description =
        this.description === 'Mostrar senha'
          ? 'Esconder senha'
          : 'Mostrar senha';
    },
  },
};
</script>
